var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.60791 7.60906C4.60791 6.39005 5.59611 5.40186 6.81512 5.40186H28.2601C29.4791 5.40186 30.4673 6.39006 30.4673 7.60906V23.4283C30.4673 24.6473 29.4791 25.6355 28.2601 25.6355H10.8656L6.22274 30.2784C5.9522 30.5489 5.54533 30.6299 5.19186 30.4835C4.83838 30.337 4.60791 29.9921 4.60791 29.6095V7.60906ZM6.81512 7.29375C6.64097 7.29375 6.4998 7.43492 6.4998 7.60906V27.3258L9.71258 24.113C9.94911 23.8765 10.2699 23.7436 10.6044 23.7436H28.2601C28.4342 23.7436 28.5754 23.6024 28.5754 23.4283V7.60906C28.5754 7.43492 28.4342 7.29375 28.2601 7.29375H6.81512Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.6312 14.4505H12.0999V12.5586H22.6312V14.4505Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.6312 18.5669H12.0999V16.675H22.6312V18.5669Z",
  fill: "white"
});

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.2b414627.svg";
export { ForwardRef as ReactComponent };